import React from 'react';
import { PresentationDeck } from './components/presentation/PresentationDeck';
export function App() {
  return <PresentationDeck data-id="element-0" />;
}